module.exports = __webpack_public_path__ + "static/media/googlePlay.342dc18d.png";